import Flickity from "flickity";

const initGalleryOverlay = (section) => {
    const body = document.querySelector('body');
    const openTriggers = section.parentNode.querySelectorAll('.js-overlay-trigger');
    const overlayClose = section.querySelector('.js-gallery-close');
    const slider = section.querySelector('.js-overlay-slider');
    const controls = section.querySelectorAll('.js-slider-button');

    const flkty = new Flickity(slider, {
        cellAlign: 'center',
        contain: true,
        prevNextButtons: false,
        cellSelector: '.js-cell',
        wrapAround: true
    });

    controls.forEach((button) => {
        const { dir } = button.dataset;
        button.addEventListener('click', () => {
            if (dir === 'prev') {
                flkty.previous();
            } else {
                flkty.next();
            }
        });
    });

    // Open/close logic

    openTriggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
            section.classList.add('is-active');
            body.classList.add('stop-scrolling');
            flkty.selectCell(index);
        });
    });

    overlayClose.addEventListener('click', () => {
        section.classList.remove('is-active');
        body.classList.remove('stop-scrolling');
    });
};

export default initGalleryOverlay;
